<!-- CONTENEDOR FIJO ABAJO-DERECHA -->
<div class="fc" [class.open]="open">

  <!-- Botón flotante -->
  <button class="fc__btn" type="button" (click)="toggle()" aria-haspopup="dialog">
    <i class="bi bi-chat"></i>
    ¡Hola, escríbenos!
  </button>

  <!-- Panel del asesor (aparece encima del botón) -->
  <div *ngIf="open" class="fc__panel" role="dialog" aria-label="Chat con asesor">
    <header class="fc__head">
      Estamos en línea para darte la mejor atención
      <button type="button" class="fc__close" (click)="close()" aria-label="Cerrar">✕</button>
    </header>

    <div class="fc__body">
      <!-- Avatar con estado superpuesto abajo-derecha -->
      <div class="fc__avatar-wrap" [attr.aria-label]="online ? 'Asesor en línea' : 'Asesor ocupado'">
        <img class="fc__avatar" [src]="avatarUrl || 'assets/footer/agente.png'" alt="Asesor">
        <span class="fc__presence" [class.off]="!online" title="{{ online ? 'En línea' : 'Ocupado' }}"></span>
      </div>

      <div class="fc__info">
        <div class="fc__role">{{ advisorRole }}</div>
        <div class="fc__name">{{ advisorName }}</div>

        <!-- (Se quitó el texto de estado) -->
        <!-- <div class="fc__status">
          <span class="fc__badge" [class.off]="!online"></span>
          {{ online ? 'Disponible' : 'Ocupado' }}
        </div> -->
      </div>
    </div>

    <div class="fc__actions">
      <button type="button" class="fc__wa" (click)="openWhatsApp()">
        💬 Chatear por WhatsApp
      </button>
    </div>

    <!-- flecha que apunta al botón -->
    <span class="fc__caret" aria-hidden="true"></span>
  </div>
</div>
